module.exports = __webpack_public_path__ + "static/media/MoneyImage.e7ed7f0a.png";